/**
 * Converte um corpo de erro da API (DRF) em uma mensagem legivel para o
 * usuario. Cobre os formatos que o backend retorna hoje: {error}/{detail}
 * (mensagem unica) e o formato padrao de erro por campo do DRF
 * ({campo: [mensagem, ...]}).
 */
export function formatServerError(data, fallback = 'Nao foi possivel completar a operacao. Verifique os dados e tente novamente.') {
  if (!data) {
    return fallback;
  }
  if (typeof data === 'string') {
    return data;
  }
  if (data.error || data.detail) {
    return data.error || data.detail;
  }
  const firstField = Object.keys(data)[0];
  if (!firstField) {
    return fallback;
  }
  const firstValue = data[firstField];
  const message = Array.isArray(firstValue) ? firstValue[0] : firstValue;
  return message ? `${firstField}: ${message}` : fallback;
}
